import { Link } from "gatsby"

export const LinkField = ({
  children,
  element,
  target,
  text,
  type,
  url,
  ...rest
}) => {
  if (type === "") return null

  const targetAttr = target === "_blank" && {
    target,
    rel: "noopener noreferrer",
  }

  if (type === "entry" && element) {
    return (
      <Link to={`/${element.uri}`} {...targetAttr} {...rest}>
        {children || text}
      </Link>
    )
  }

  return (
    <a href={url} {...targetAttr} {...rest}>
      {children || text}
    </a>
  )
}
